enum SolicitorsActionsEnum {
    SolicitorsList = 'SOLICITORS/LIST',
    SolicitorsSet = 'SOLICITORS/SET',
}

export default SolicitorsActionsEnum;
